module.exports = __webpack_public_path__ + "img/@work_img6.b85618fe.jpg";